/**
 * 说明框
 * 对应设计稿 .notebox。用来解释业务口径，比如"赠送余额不参与提成"。
 * 这类说明是产品文档「不允许算不清」原则在界面上的兑现，不要为了好看删掉。
 */
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { Icon, type IconName } from '@/components/icons';

type NoteTone = 'brand' | 'ok' | 'warn' | 'danger';

const TONE_CLASS: Record<NoteTone, string> = {
  brand: 'bg-brand-pale border-brand-line text-brand-2',
  ok: 'bg-green-pale border-[#CFE4D9] text-green',
  warn: 'bg-amber-pale border-[#F0DFB8] text-amber',
  danger: 'bg-red-pale border-[#F2D2CB] text-red',
};

const TONE_ICON: Record<NoteTone, IconName> = {
  brand: 'bulb',
  ok: 'check',
  warn: 'alert',
  danger: 'alert',
};

export function NoteBox({
  tone = 'brand',
  title,
  children,
  className,
}: {
  tone?: NoteTone;
  title?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex gap-2.5 rounded-md border px-3.5 py-[13px] text-form leading-relaxed',
        TONE_CLASS[tone],
        className,
      )}
    >
      <span className="mt-0.5 shrink-0">
        <Icon name={TONE_ICON[tone]} size={15} />
      </span>
      <div className="min-w-0">
        {title && <b className="mb-[3px] block text-table">{title}</b>}
        <p className="m-0">{children}</p>
      </div>
    </div>
  );
}
